import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSEO } from '../hooks/useSEO'

const PrivacyPolicy: React.FC = () => {
  const { t } = useTranslation()

  useSEO({
    title: `${t('privacy.title')} - Chiang Mai Living Hub`,
    description: t('privacy.description'),
    keywords: 'privacy policy, data, cookies, analytics, chiang mai living hub'
  })

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-4">{t('privacy.title')}</h1>
        <p className="text-gray-600 dark:text-gray-300 mb-8">{t('privacy.subtitle')}</p>

        <div className="space-y-8 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">{t('privacy.whatWeCollect.title')}</h2>
            <p className="text-sm text-gray-700 dark:text-gray-300">{t('privacy.whatWeCollect.body')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">{t('privacy.howWeUse.title')}</h2>
            <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700 dark:text-gray-300">
              <li>{t('privacy.howWeUse.items.0')}</li>
              <li>{t('privacy.howWeUse.items.1')}</li>
              <li>{t('privacy.howWeUse.items.2')}</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">{t('privacy.cookies.title')}</h2>
            <p className="text-sm text-gray-700 dark:text-gray-300">{t('privacy.cookies.body')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">{t('privacy.dataRetention.title')}</h2>
            <p className="text-sm text-gray-700 dark:text-gray-300">{t('privacy.dataRetention.body')}</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">{t('privacy.contact.title')}</h2>
            <p className="text-sm text-gray-700 dark:text-gray-300">{t('privacy.contact.body')}</p>
          </section>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicy


